import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchCandidateEmailsFailed,
  fetchCandidateEmailsSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';

const { API_BASE_URL } = urls || {};

function* fetchEmails({ payload }) {
  const url = `${API_BASE_URL}/email/candidates/${payload}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchCandidateEmailsSuccess(response?.raw || []));
  } else {
    yield put(fetchCandidateEmailsFailed(response.message));
  }
}

export function* getApplicantEmails() {
  yield takeEvery(
    ApplicantsActionTypes.FETCH_EMAIL_START,
    fetchEmails
  );
}
